import {v4 as uuidv4} from 'uuid';

export const getEntity = props => ({
  id: uuidv4(),
  src: '',
  preview: '',
  caption: '',
  action: 'Do',
  title: '',
  ...props
});

export const getColorEntity = () => ({
  id: uuidv4(),
  title: '',
  description: '',
  hexCode: '',
  cmykCode: '',
  pantoneCode: '',
  highlight: false,
});
